import React from "react";
import Container from "Components/Container/Container";
import { Link } from "react-router-dom";
import bg from "assests/Carrers/1.jpg";
const Hero = ({ data }) => {
  return (
    <section
      className="scroll-section-special background py-36 lg:py-0"
      style={{ backgroundImage: `url(${data?.background})` }}
    >
      <Container className="lg:h-[100vh]">
        <div className="min-h-full  flex flex-col items-center justify-center">
          <span className="flex items-center text-font text-2xl  gap-x-2 mb-2 ">
            <Link className="hover:underline" to={"/"}>
              Home
            </Link>
            <span>|</span>
            <p>Careers</p>
          </span>
          <h1 className="bebas text-white text-6xl md:text-7xl lg:text-8xl">
            Careers
          </h1>

          <h4 className="mt-12 bebas text-4xl lg:text-5xl text-white">
            {data?.title}
          </h4>
          <div
            className="text-white text-lg  leading-[1.6] lg:w-3/4 mx-auto text-center "
            dangerouslySetInnerHTML={{ __html: data?.text }}
          />
        </div>
      </Container>
    </section>
  );
};

export default Hero;
